import React from 'react';

export const NetworkingConfig = {
    settings: {
        layout: {
            config: {
                header: { display: true },
                footer: { display: true },
                navbar: { display: true },
            },
        },
    },
    isPrivate: true,
    eventName: 'networking_room',
    routes: [
        {
            path: '/:organizationId/:eventSlug/networking/:roomId',
            component: React.lazy(() => import('./Networking')),
        },
    ],
};
